import React from 'react';
import useBetslip from '../useBetslip';

export default function BannerOdd(props) {
    const data = props.data;
    const [addBet, selected] = useBetslip(data);

    if (data == null) {
        return null;
    }

    const desc = data.desc;

    return (
        <>
            {selected ?
                <div className="xs_bannerOdd w-fit flex justify-between items-center px-1 py-1 mr-1 last:mr-0 rounded-md bg-odd-selected border border-odd-selected-border truncate" onClick={addBet}>
                    <span className="text-fs2 font-medium uppercase text-odd-selected-contrast-1 truncate">{desc}</span>
                    {data.value != null ?
                        <span className="ml-1 text-fs2 font-medium uppercase text-odd-selected-contrast-1">
                            {data.value}
                        </span>
                        :
                        <i className="bi-lock" />
                    }
                </div>
                :
                <div className="xs_bannerOdd w-fit flex justify-between items-center px-1 py-1 mr-1 last:mr-0 rounded-md bg-odd border border-odd-border truncate" onClick={addBet}>
                    <span className="text-fs2 font-medium uppercase text-odd-contrast-1 truncate">{desc}</span>
                    {data.value != null ?
                        <span className="ml-1 text-fs2 font-medium uppercase text-odd-contrast-1">
                            {data.value}
                        </span>
                        :
                        <i className="bi-lock" />
                    }
                </div>
            }
        </>
    );
}
